(function () {
  var SCROLL_THRESHOLD = 80;
  var lastScrollY = 0;
  var ticking = false;
  var header = null;

  function isBlocked() {
    var body = document.body;
    if (!body) return true;
    if (body.classList.contains('js-drawer-open-left')) return true;
    if (body.classList.contains('js-drawer-open-right')) return true;
    if (body.classList.contains('js-drawer-open')) return true;
    if (header && (header.querySelector('.nav-hover') || header.querySelector('.force-open'))) {
      return true;
    }
    return false;
  }

  function updateHeader() {
    ticking = false;
    if (!header || !header.classList.contains('sticky-header') || !header.classList.contains('sticked')) {
      if (header) header.classList.remove('header-scroll-hidden');
      return;
    }

    var scrollY = window.scrollY || document.documentElement.scrollTop || 0;

    if (isBlocked() || scrollY <= SCROLL_THRESHOLD) {
      header.classList.remove('header-scroll-hidden');
      lastScrollY = scrollY;
      return;
    }

    if (scrollY > lastScrollY + 2) {
      header.classList.add('header-scroll-hidden');
    } else if (scrollY < lastScrollY - 2) {
      header.classList.remove('header-scroll-hidden');
    }

    lastScrollY = scrollY;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateHeader);
    }
  }

  function init() {
    header = document.querySelector('.shopify-section.header-section.sticky-header');
    if (!header) return;

    lastScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('headerSticked', onScroll);
    document.addEventListener('headerUnstuck', onScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
